export const GOOGLE_SSO_ENABLED_HOSTNAMES = [
  'demo-app-maisonsdumonde.revers.io',
  'app-maisonsdumonde.revers.io',
  'app2-maisonsdumonde.revers.io',
];

export const isUsingGoogleSso = () => {
  if (window?.location?.hostname === 'localhost') {
    return false;
  }

  return GOOGLE_SSO_ENABLED_HOSTNAMES.includes(
    typeof window !== 'undefined' ? window.location.hostname : '',
  );
};
